import Card from '@components/common/Card';
import styled from 'styled-components';

export const Hero = styled.section`
  background: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.functional.white};
  display: flex;
  h2 {
    margin-bottom: 2.4rem;
  }
`;

export const HeroWrapper = styled.div`
  padding: 64px 0 128px;
  position: relative;
  img {
    position: absolute;
    right: 0;
    bottom: 60px;
    width: 450px;
    max-width: 50%;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    padding: 48px 0 43px 0;
    img {
      position: relative;
      bottom: 0;
      max-width: 100%;
    }
  }
`;

export const HeroText = styled.div`
  width: 390px;
  max-width: 95%;
`;

export const StyledCard = styled(Card)`
  width: 67%;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem 0 4rem;
  margin: 8rem auto 6rem;
  color: ${({ theme }) => theme.colors.primary.main};
  h3 {
    margin-bottom: 2rem;
  }
  h4 {
    font-weight: 400;
  }
  p {
    margin-bottom: 0;
  }
`;
